import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { BuildingType } from "../../data";

@Component({
    selector: "[app-library-roof]",
    templateUrl: "./library-roof.component.html",
    styleUrl: "./library-roof.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LibraryRoofComponent {
  type = input<BuildingType>();
}
